// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1079M","Footer__nav":"Footer_Footer__nav__3Z1uO","Footer__nav-item":"Footer_Footer__nav-item__AqMLM","Footer__nav-link":"Footer_Footer__nav-link__27wnz"};